import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserGuideinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.419,
		d: "m9.703 4.095-6.174 3.43c-1.298.721-1.298 2.587 0 3.308l6.174 3.43a4.73 4.73 0 0 0 4.594 0l6.174-3.43c1.298-.721 1.298-2.587 0-3.308l-6.174-3.43a4.73 4.73 0 0 0-4.594 0",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.417,
		d: "M5.991 12.2v3.924c0 .949.475 1.834 1.264 2.359l1.607 1.069a5.67 5.67 0 0 0 6.275 0l1.607-1.069a2.83 2.83 0 0 0 1.264-2.359V12.2"
	})]
});
export default SvgUserGuideinline;
